import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Categoria } from 'src/app/model/categoria';
import { CategoriaService } from 'src/app/services/api/categoria.service';

declare let $: any;
@Component({
  selector: 'app-sidebar-ecomerce',
  templateUrl: './sidebar-ecomerce.component.html',
  styleUrls: ['./sidebar-ecomerce.component.css']
})
export class SidebarEcomerceComponent implements OnInit {
  @ViewChild('myModal')
  myModal!: ElementRef;
  categoriadto:Categoria[]=[];
  constructor(
    //  private productoDTOService : ProductoDTOService,
     
      private categoriaService : CategoriaService,
      private router:Router,
  
    ) { 
      
    }
  ngOnInit(): void {
this.OnGetCategoria();

  }



  OnGetCategoria(){
   
    this.categoriaService.getCategoria().subscribe(response =>{
      console.log(response)
      return this.categoriadto=response
    })
  }

  OnIraInicio(){

    this.router.navigate(['/inicio', ])
  .then(() => {
    window.location.reload();
  });
}


OnIraArticulos(_idcategoria:any){
  this.router.navigate(['/articulos',_idcategoria ])
  .then(() => {
    window.location.reload();
  });

}

OnIraPedidoCliente(){
  this.router.navigate(['/pedido-cliente', ])
  .then(() => {
    window.location.reload();
  });
}


OnIraPoliticas(){
  this.router.navigate(['/privacity', ])
  .then(() => {
    window.location.reload();
  });
}

OnAbrirPoliticaCambio(){

  $(this.myModal.nativeElement).modal('show'); 


}

OnIraCambios(){


    
    





  this.router.navigate(['/cambio', ])
  .then(() => {
    window.location.reload();
  });
}


}




